import React from "react";
import Style from "./Toast.module.css";
import Success from "../../../assets/svg/Success.svg";
import Error from "../../../assets/svg/Error.svg";
import { Cross } from "../../../modules/default-svg";

const ToastItem = (props) => {
  const { toast, removeToast } = props;
  return (
    <div className="z-3">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-between align-items-center">
          <img
            src={toast !== null && toast.type === "success" ? Success : Error}
            alt={toast?.type}
          />
          <p className={`${Style.toastTitle} text-sm-600 subHeading-color`}>
            {toast ? toast.title : ""}
          </p>
        </div>
        <span onClick={removeToast} className="d-inline-flex cursor-pointer">
          <Cross />
        </span>
      </div>
    </div>
  );
};

export default ToastItem;
